/**
 * @generated SignedSource<<5e67cdfb39d42a336b7e5cfe21f6f2b3>>
 * @relayHash 99681afa8eb0a038261097b782f886ad
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 99681afa8eb0a038261097b782f886ad

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      }
    ],
    "concreteType": "CommercialCode",
    "kind": "LinkedField",
    "name": "commercialCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCheckCommercialCodeQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCheckCommercialCodeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "99681afa8eb0a038261097b782f886ad",
    "metadata": {},
    "name": "useCheckCommercialCodeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "b9690f04f9f2ee2741058549fecc728c";

export default node;
